import { rolePrettyNames } from "../constants/roles";

const WORD_LIST = [
  "amber", "brave", "cedar", "delta", "eager", "frost", "grace", "haven",
  "ivory", "jade", "karma", "lunar", "maple", "noble", "ocean", "pearl",
  "quest", "river", "storm", "tiger", "ultra", "valor", "wheat", "xenon",
  "yield", "zonal", "alpha", "brisk", "crisp", "drift",
];

/**
 * Generates a pronounceable password: word + number + symbol + year
 * e.g. "amber42@2025"
 */
export const generatePassword = () => {
  const word = WORD_LIST[Math.floor(Math.random() * WORD_LIST.length)];
  const number = Math.floor(Math.random() * 90) + 10; // 10-99
  const symbol = Math.random() > 0.5 ? "@" : "#";
  const year = new Date().getFullYear();
  return `${word}${number}${symbol}${year}`;
};

/**
 * Returns display label for a role key
 */
export const getRolePrettyName = (roleKey) =>
  rolePrettyNames[roleKey] ?? roleKey;

/**
 * Filters users based on search text, selected labs, selected authority,
 * and the unassigned-only checkbox.
 */
export const filterUsers = (users, { searchText, searchFields, selectedLabs, selectedAuthority, unassignedOnly, labRoleMap }) => {
  return users.filter((user) => {
    // unassigned filter: only DASHBOARD_USER role (no lab viewer role)
    if (unassignedOnly) {
      const hasLabRole = Object.values(labRoleMap).some((r) => user.roles.includes(r));
      const hasElevatedRole = user.roles.includes("ADMIN") || user.roles.includes("NPHL_VIEWER");
      if (hasLabRole || hasElevatedRole) return false;
    }

    // lab filter
    if (selectedLabs.length > 0) {
      const requiredRoles = selectedLabs.map((lab) => labRoleMap[lab]);
      const hasAnyLab = requiredRoles.some((r) => user.roles.includes(r));
      if (!hasAnyLab) return false;
    }

    // authority filter
    if (selectedAuthority) {
      if (user.authority !== selectedAuthority) return false;
    }

    // text search
    if (searchText.trim()) {
      const q = searchText.toLowerCase();
      const matchName = searchFields.includes("name") &&
        `${user.first_name} ${user.last_name}`.toLowerCase().includes(q);
      const matchEmail = searchFields.includes("email") &&
        user.email.toLowerCase().includes(q);
      if (!matchName && !matchEmail) return false;
    }

    return true;
  });
};

/**
 * Sorts users by first_name then last_name (default), or by a given field.
 */
export const sortUsers = (users, sortField = "name", sortOrder = "asc") => {
  return [...users].sort((a, b) => {
    let valA, valB;
    if (sortField === "name") {
      valA = `${a.first_name} ${a.last_name}`.toLowerCase();
      valB = `${b.first_name} ${b.last_name}`.toLowerCase();
    } else {
      valA = (a[sortField] ?? "").toLowerCase();
      valB = (b[sortField] ?? "").toLowerCase();
    }
    const cmp = valA.localeCompare(valB);
    return sortOrder === "asc" ? cmp : -cmp;
  });
};